export default "__VITE_ASSET__ClT9jw3F__"